import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import {t} from "../common/i18n.js";
import {
  getPrintTemplateUrlForProduct,
  withAttrs
} from "../common/utils.js";
import Button from "./button.js";
import {ArrowDown} from "./icons.js";
export default function PrintTemplateDownloadButton(props) {
  const {product, config, article, disabled = false, ...rest} = props;
  if (disabled)
    return null;
  const downloadUrl = getPrintTemplateUrlForProduct(product, article, config);
  if (!downloadUrl)
    return null;
  return /* @__PURE__ */ React.createElement(Container, {
    href: downloadUrl,
    target: "_blank",
    ...rest
  }, t("Druckvorlage runterladen"), " ", /* @__PURE__ */ React.createElement(ArrowDown, null));
}
const Container = styled(withAttrs(Button, {stretch: true, small: true, secondary: true}))`
  height: 46px;

  svg {
    transition: margin-top 0.2s ease;
  }

  &:hover {
    svg {
      margin-top: 5px;
    }
  }
`;
